// extracted by mini-css-extract-plugin
export default {"container":"WXqMKOCR0lJfXsvlW7ldsA==","close-button":"wVcyHIqJnUUDA2ehTojYkQ=="};